import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MemoryLayout } from './components/MemoryLayout';
import { IntroPanel } from './components/IntroPanel';
import { CityPanel } from './components/CityPanel';
import { NotFoundPanel } from './components/NotFoundPanel';
import { PhotoLightbox } from './components/PhotoLightbox';
import { IndexGallery } from './pages/IndexGallery';

const CANONICAL_ORIGIN = 'https://memory-globe.rokass.org';

function CanonicalLink() {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) throw new Error('index.html is missing <link rel="canonical">');
    link.href = `${CANONICAL_ORIGIN}${pathname}`;
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <CanonicalLink />
      <Routes>
        <Route element={<MemoryLayout />}>
          <Route path="/" element={<IntroPanel />} />
          <Route path="/city/:slug" element={<CityPanel />}>
            <Route path="photo/:photoId" element={<PhotoLightbox from="globe" />} />
          </Route>
          <Route path="*" element={<NotFoundPanel />} />
        </Route>
        <Route path="/list" element={<IndexGallery />}>
          <Route path=":slug/photo/:photoId" element={<PhotoLightbox from="list" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
